import React, {useRef} from "react";
import {findDOMNode} from "react-dom";
import Classes from "classnames";
import Popover from "../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../gd-components/gd-popover/popover-position";
import {PopoverAttachmentType} from "../../../../gd-components/gd-popover/@const";
import {FieldPopoverProps} from "../../../proto/types";
import AttachmentsManager from "../../../../gd-components/files/attachments-manager/attachments-manager";
import {AttachFileMode} from "../../../../gd-components/files/const";
import AttachmentsCollection from "../../../../model2/attachment/attachments";

const popoverPosition = new PopoverPosition({
    attachment      : "top center",
    targetAttachment: "bottom center",
    attachmentType  : PopoverAttachmentType.FULL,
})

export default function FieldAttachments_Popover(props:FieldPopoverProps) {

    const attachmentsRef = useRef<any>(null);

    return (
        <Popover position={popoverPosition}
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>
            <div className={Classes("ui5-popover-selector", "cards-selector", "p-10")}>
                <AttachmentsManager  ref={attachmentsRef}
                                     mode={AttachFileMode.VIEW}
                                     className="m-l-15 m-t-10"
                                     attachmentsCollection={new AttachmentsCollection(props.model.attachments)}/>
            </div>
        </Popover>
    )
}
